<template>
  <div
    @click="openModal"
    class="our-team-card"
  >
    <img
      :src="result.img.src"
      :alt="result.img.alt"
      :title="result.img.title"
      alt="result.img"
      class="our-team-card__image"
    >
    <h6 class="our-team-card__name">
      {{ result.name }}
    </h6>
    <p class="our-team-card__position">
      {{ result.worckPosition }}
    </p>
  </div>
</template>

<script>
import { useAModal } from "../ui";
import {useTeam} from "../../composables/useTeam";


export default {
  name: 'OurTeamCard',
  props: ['result'],
  setup({ result }) {

    const modal = useAModal();
    const { setActiveMember } = useTeam();
    const openModal = () => {
      setActiveMember(result);
      modal.show('team-member');
    }

    return {
      openModal,
    }
  }
}
</script>

<style lang="scss" scoped>
.our-team-card {
  cursor: pointer;
  &__image {
    display: block;
    margin-bottom: 19px;
    border-radius: 6px;
    width: 100%;
  }
  &__name{
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 4px;
    @include mobile{
      width: min-content;
    }
  }
  &__position{
    font-size: 14px;
    line-height: 20px;
    color: #00A59E;
    margin-bottom: 0;
  }
}
</style>